import { render, staticRenderFns } from "./ModalCouponDiscount.vue?vue&type=template&id=4ae59320&"
import script from "./ModalCouponDiscount.vue?vue&type=script&lang=js&"
export * from "./ModalCouponDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports